import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.60177 1.98256C5.02455 2.33791 5.07921 2.96871 4.72386 3.39149C3.75197 4.54779 3.05153 5.93763 2.71842 7.46366C2.60063 8.00324 2.06774 8.34517 1.52816 8.22739C0.988577 8.10961 0.646644 7.57671 0.764427 7.03713C1.16846 5.1862 2.01769 3.50277 3.19284 2.10465C3.54819 1.68187 4.17899 1.62721 4.60177 1.98256ZM19.398 1.98256C19.8207 1.62721 20.4515 1.68187 20.8069 2.10465C21.982 3.50278 22.8313 5.1862 23.2353 7.03713C23.3531 7.57671 23.0112 8.10961 22.4716 8.22739C21.932 8.34517 21.3991 8.00324 21.2813 7.46366C20.9482 5.93763 20.2478 4.54779 19.2759 3.39149C18.9205 2.96871 18.9752 2.33791 19.398 1.98256ZM4.21563 8.81524C4.73583 4.91377 8.06385 2.00004 11.9998 2.00004C15.9358 2.00004 19.2639 4.91377 19.7841 8.81524L20.6892 15.6035C20.929 17.402 19.5298 19 17.7155 19H16.6462C15.7421 20.748 14.0385 22 11.9998 22C9.96121 22 8.25762 20.748 7.35347 19H6.28421C4.46984 19 3.07073 17.402 3.31053 15.6035L4.21563 8.81524ZM9.77806 19C10.387 19.6373 11.1766 20 11.9998 20C12.8231 20 13.6127 19.6373 14.2216 19H9.77806ZM11.9998 4.00004C9.06626 4.00004 6.5858 6.17171 6.19809 9.07957L5.29298 15.8679C5.21305 16.4674 5.67942 17 6.28421 17H17.7155C18.3203 17 18.7866 16.4674 18.7067 15.8679L17.8016 9.07957C17.4139 6.17171 14.9334 4.00004 11.9998 4.00004Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }